import React from 'react';
import { useMutation } from '@apollo/client';
import TrackerRemoveActivityMutation from './TrackerRemoveActivityMutation';
import TrackerQuery from '../Fetch/TrackerQuery';

interface ITrackerRemoveActivityConnectorApolloProps {
  children: ({
    removeActivity,
  }: {
    removeActivity: (activityId: number) => Promise<any>;
  }) => React.ReactElement;
  date: string;
}

const TrackerRemoveActivityConnectorApollo: React.FC<
  ITrackerRemoveActivityConnectorApolloProps
> = ({ children, date }) => {
  const [removeActivityMutation] = useMutation(TrackerRemoveActivityMutation, {
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: TrackerQuery,
        variables: {
          date,
        },
      },
    ],
  });

  const removeActivity = async (activityId: number) => {
    const response = await removeActivityMutation({
      variables: { activityId },
    });

    return response.data.dailyTracker.removeActivity;
  };
  return children({ removeActivity });
};

export default TrackerRemoveActivityConnectorApollo;
